/** Avoid running the same function twice within the specified timeframe. */
const debounce = (func, wait) => {
    let timeout;
    return function (...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.call(this, ...args), wait);
    };
};

export { debounce as d };

//# sourceMappingURL=debounce-9c93e0a1.js.map